import React from 'react';

const ProjectionTable = ({ projections }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  const formatPercentage = (value) => {
    return `${value?.toFixed(1)}%`;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-6 py-4 border-b border-border bg-muted/30">
        <h3 className="font-heading font-bold text-lg text-foreground">
          5-Year Financial Projections
        </h3>
        <p className="font-body text-sm text-muted-foreground mt-1">
          Detailed annual breakdown with growth projections
        </p>
      </div>
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/20">
            <tr>
              <th className="px-6 py-4 text-left font-heading font-semibold text-sm text-foreground">
                Year
              </th>
              <th className="px-6 py-4 text-right font-heading font-semibold text-sm text-foreground">
                Gross Revenue
              </th>
              <th className="px-6 py-4 text-right font-heading font-semibold text-sm text-foreground">
                Operating Costs
              </th>
              <th className="px-6 py-4 text-right font-heading font-semibold text-sm text-foreground">
                Net Income
              </th>
              <th className="px-6 py-4 text-right font-heading font-semibold text-sm text-foreground">
                Growth Rate
              </th>
              <th className="px-6 py-4 text-right font-heading font-semibold text-sm text-foreground">
                ROI
              </th>
            </tr>
          </thead>
          <tbody>
            {projections?.map((projection, index) => (
              <tr key={projection?.year} className={index % 2 === 0 ? 'bg-background' : 'bg-muted/10'}>
                <td className="px-6 py-4 font-body font-semibold text-foreground">
                  Year {projection?.year}
                </td>
                <td className="px-6 py-4 font-mono font-medium text-right text-foreground">
                  {formatCurrency(projection?.grossRevenue)}
                </td>
                <td className="px-6 py-4 font-mono font-medium text-right text-destructive">
                  {formatCurrency(projection?.operatingCosts)}
                </td>
                <td className="px-6 py-4 font-mono font-bold text-right text-success">
                  {formatCurrency(projection?.netIncome)}
                </td>
                <td className="px-6 py-4 font-mono font-medium text-right text-muted-foreground">
                  {formatPercentage(projection?.growthRate)}
                </td>
                <td className="px-6 py-4 font-mono font-medium text-right text-primary">
                  {formatPercentage(projection?.roi)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile Cards */}
      <div className="lg:hidden space-y-4 p-4">
        {projections?.map((projection) => (
          <div key={projection?.year} className="bg-background border border-border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-heading font-bold text-lg text-foreground">
                Year {projection?.year}
              </h4>
              <div className="flex items-center space-x-2">
                <span className="font-body text-xs text-muted-foreground">Growth:</span>
                <span className="font-mono font-medium text-sm text-primary">
                  {formatPercentage(projection?.growthRate)}
                </span>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="font-body text-xs text-muted-foreground mb-1">Gross Revenue</p>
                <p className="font-mono font-semibold text-sm text-foreground">
                  {formatCurrency(projection?.grossRevenue)}
                </p>
              </div>
              <div>
                <p className="font-body text-xs text-muted-foreground mb-1">Operating Costs</p>
                <p className="font-mono font-semibold text-sm text-destructive">
                  {formatCurrency(projection?.operatingCosts)}
                </p>
              </div>
              <div>
                <p className="font-body text-xs text-muted-foreground mb-1">Net Income</p>
                <p className="font-mono font-bold text-base text-success">
                  {formatCurrency(projection?.netIncome)}
                </p>
              </div>
              <div>
                <p className="font-body text-xs text-muted-foreground mb-1">ROI</p>
                <p className="font-mono font-semibold text-sm text-primary">
                  {formatPercentage(projection?.roi)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectionTable;